<template>
  <div>
    <Input
      :value="data"
      :readonly="readonly"
      :roles="roles"
      @update="update"
    />
  </div>
</template>
  
<script>
  import Input from '@/components/bpcreator/inputs/Input';
  export default {
    components: {
      Input,
    },
      
    name: 'GenericView',
      
    props: {
      name: {},
      data: {default: () => ({})},
      readonly: Boolean,
      roles: {default: ()=>({})},
    },
      
    data: () => ({
    }),
      
    computed: {
      is_object() {
        return typeof(this.data) == 'object';
      },
    },
      
    mounted() {
    },
      
    methods: {
      update(value) {
        this.$emit('update',value);
      }
    },
  
    watch: {
    },
  }
</script>